import { DashboardOutlined, AppstoreAddOutlined, UnorderedListOutlined, GiftOutlined, PictureOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';


export const menuConfig = {
    'marketing':[
        {
            key: 'dashboard',
            label: <Link to="/asm/marketing/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'campaign-gallery',
            label: <Link to="/asm/marketing/campaign-gallery">Campaign Gallery</Link>,
            icon: <PictureOutlined />
        },
    ],
    'manager':[
        {
            key: 'dashboard',
            label: <Link to="/asm/manager/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'history',
            label: <Link to="/asm/manager/history">History</Link>,
            icon: <UnorderedListOutlined />
        },
        {
            key: 'check_discount',
            label: <Link to="/asm/manager/check_discount">Check Discount</Link>,
            icon: <AppstoreAddOutlined />
        },

    ],
    'employee_discount':[
        {
            key: 'dashboard',
            label: <Link to="/asm/employee_discount/dashboard">Employee Discount</Link>,
            icon: <GiftOutlined />
        },
        {
            key: 'history',
            label: <Link to="/asm/employee_discount/history">History</Link>,
            icon: <UnorderedListOutlined />
        },
        {
            key: 'purchase_history',
            label: <Link to="/asm/employee_discount/purchase_history">Purchase History</Link>,
            icon: <UnorderedListOutlined />
        },
    ],
    'mining':[
        {
            key: 'dashboard',
            label: <Link to="/asm/mining/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'mining_audio',
            label: <Link to="/asm/mining/mining_audio">Mining Audio</Link>,
            icon: <UnorderedListOutlined />
        },
        // {
        //     key: 'push_lead',
        //     label: <Link to="/asm/mining/push_lead">Push Leads</Link>,
        //     icon: <UnorderedListOutlined />
        // }
    ],
    // 'vas':[
    //     {
    //         key: 'dashboard',
    //         label: <Link to="/asm/vas/dashboard">Dashboard</Link>,
    //         icon: <DashboardOutlined />
    //     }
    // ],
    'ranking':[
        {
            key: 'dashboard',
            label: <Link to="/asm/ranking/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'store-details',
            label: <Link to="/asm/ranking/store-details">Store Details</Link>,
            icon: <UnorderedListOutlined />
        }
    ],
    'spl':[
        {
            key: 'dashboard',
            label: <Link to="/asm/spl/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'store-bucket',
            label: <Link to="/asm/spl/store-bucket">Store Bucket</Link>,
            icon: <UnorderedListOutlined />
        },
        {
            key: 'employees-bucket',
            label: <Link to="/asm/spl/employees-bucket">Employees Bucket</Link>,
            icon: <UnorderedListOutlined />
        }
    ],
    'qr':[
        {
            key: 'dashboard',
            label: <Link to="/asm/qr/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'qr_payment_history',
            label: <Link to="/asm/qr/qr_payment_history">Payment History</Link>,
            icon: <UnorderedListOutlined />
        }
    ],
    'exchange':[
        {
            key: 'dashboard',
            label: <Link to="/asm/exchange/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'history',
            label: <Link to="/asm/exchange/history">History</Link>,
            icon: <UnorderedListOutlined />
        },
    ],
    'finance':[
        {
            key: 'dashboard',
            label: <Link to="/asm/finance/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        // {
        //     key: 'cashify_processing',
        //     label: <Link to="/asm/finance/finance_processing">Finance Processing</Link>,
        //     icon: <CheckSquareOutlined />
        // },
        {
            key: 'finance_history',
            label: <Link to="/asm/finance/finance_history">History</Link>,
            icon: <UnorderedListOutlined />
        },
    ]

};
